<div class="demooz_tag"
    [class.no_margin]="this.noMargin"
    [class.is_clickable]="this.isClickable"
    [class.disabled]="this.disabledTag"
    [class.big]="this.sizeTag === 'big'"
    [class.small]="this.sizeTag === 'small'"
    [class.secondary]="this.colorTag === 'secondary'"
    [class.blue]="this.colorTag === 'blue'"
    [class.red]="this.colorTag === 'red'"
    [class.green]="this.colorTag === 'green'"
    [class.orange]="this.colorTag === 'orange'"
    [class.purple]="this.colorTag === 'purple'"    
    [class.demoozesting]="this.colorTag === 'demoozesting'" 
    (click)="this.clickTag($event)"
    >
    @if(this.iconTag !== ''){
         <ion-icon class="demooz_tag_icon" [name]="this.iconTag"></ion-icon>
    }
    <div class="demooz_tag_content">
        <ng-content></ng-content>
    </div>
    @if(this.showCloseButton){
        <ion-icon class="demooz_tag_close" name="close-circle-outline" (click)="this.closeTag($event)"></ion-icon>
    }    
</div>